import { ReactElement } from "react";
import { Redirect } from "react-router-dom";
import { AnalyticsAI } from "@jsq/analytics-components";
import { User } from "~/types/user";
import { isCanopyAnalyst, getRedirectPath } from "~/utils/userRoles";
import { CANOPY_ARENA_ID } from "./constants";

interface Props {
  currentUser: User;
}

export const Analytics = ({ currentUser }: Props): ReactElement => {
  if (!isCanopyAnalyst(currentUser.roles)) {
    return <Redirect to={getRedirectPath(currentUser)} />;
  }

  return (
    <AnalyticsAI
      arenaId={CANOPY_ARENA_ID}
      userId={currentUser.id}
      data-testid="analytics-page"
    />
  );
};
